import React, { useReducer, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDialogActions } from 'cityads-v3/hooks/dialog'
import classes from './Preview.scss'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import Preview, { PreviewProps } from './Preview'
import Tooltip from 'cityads-v3/components/Tooltip/Tooltip'
import Typography from '@mui/material/Typography'
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined'

type PreviewButtonProps = PreviewProps & {}

export default function PreviewButton({ id }: PreviewButtonProps): JSX.Element {
  const { t } = useTranslation(['main'])
  const [open, setOpen, setClose] = useDialogActions()
  const customReload = useReducer(r => r + 1, 0)
  const dimensionsInfo = useState<string>('');

  return (
    <>
      <Tooltip isLight title={t('main:preview')}>
        <IconButton onClick={setOpen} size="large">
          <VisibilityIcon />
        </IconButton>
      </Tooltip>

      <Dialog
        open={open}
        onClose={setClose}
      >
        <DialogContent>
          <Preview
            id={id}
            customReload={customReload}
            dimensionsInfo={dimensionsInfo}
          />
        </DialogContent>

        <DialogActions classes={{ root: classes.info }}>
          <Typography>
            {dimensionsInfo[0]}
          </Typography>
          <Button onClick={customReload[1]}>
            {t('main:buttons.refresh')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
